import React from "react";

const Banner = () => {
  return <main className="banner"><a href="https://paybox.doare.org/paybox?payboxId=fb835d18-d20a-4e17-ad7e-63273ec37c81" target="_blank"></a></main>;
};

export default Banner;
